import React from 'react';
import moment from 'moment';

import { InformationCallout, WarningCallout } from '../../../components/callout';
import { getUserName } from '../../../../common/utils/user/getUserName';

const formatLocationAndPlace = (location, place) => (
	[location?.name, place?.name].filter(Boolean).join(' — ') || 'Not available'
);
const referenceId = value => value?.id || value?._id || '';
const sameOptionalReference = (left, right) => referenceId(left) === referenceId(right);

const SetupMoveStatus = ({ pointOfSaleLabel, setup }) => {
	if (!setup?.movePlanId || !setup?.movePlannedAt) {
		return null;
	}

	const isConfirmed = Boolean(setup.moveConfirmedAt);
	const actionDate = isConfirmed ? setup.moveConfirmedAt : setup.movePlannedAt;
	const actionUser = isConfirmed ? setup.moveConfirmedBy : setup.movePlannedBy;
	const pointOfSale = setup.plannedMachine || setup.machine;
	const needsReplanning = Boolean(!isConfirmed && (
		!setup.plannedMachine ||
		setup.plannedMachine.destroyed ||
		!setup.plannedMachine.location ||
		!setup.moveSourceLocation ||
		!sameOptionalReference(setup.plannedMachine.location, setup.moveSourceLocation) ||
		!sameOptionalReference(setup.plannedMachine.place, setup.moveSourcePlace)
	));
	const lines = [
		isConfirmed ? 'Site move confirmed' : needsReplanning ? 'Site move needs replanning' : 'Site move planned',
		`${pointOfSaleLabel}: ${pointOfSale?.assetId || 'No longer available'}`,
		`${isConfirmed ? 'Source' : 'Current source'}: ${formatLocationAndPlace(setup.moveSourceLocation, setup.moveSourcePlace)}`,
		`Planned destination: ${formatLocationAndPlace(setup.locationSetup?.location, setup.place)}`,
		`${isConfirmed ? 'Confirmed' : 'Planned'} by ${getUserName(actionUser)} on ${moment(actionDate).format('DD MMM YYYY [at] h:mm A')}`,
		isConfirmed
			? `The live ${pointOfSaleLabel.toLowerCase()} now uses the destination setup details.`
			: needsReplanning
				? `The live ${pointOfSaleLabel.toLowerCase()}'s current location or place no longer matches the saved source. An authorised administrator must cancel and replan this move in Sentry web.`
				: `The live ${pointOfSaleLabel.toLowerCase()} remains at its current source until an authorised administrator confirms or cancels the move in Sentry web.`,
	];
	const Callout = isConfirmed ? InformationCallout : WarningCallout;

	return <Callout text={lines.join('\n')} />;
};

export default SetupMoveStatus;
